import React, { useState } from "react";
import tw from "twin.macro";
import axios from 'axios';
import PortfolioHolTable from "./PortfolioHolTable";
import styled from 'styled-components';

const Container = tw.div`bg-gray-100 px-4 py-2 rounded-lg border border-gray-300 flex flex-col items-center`;
const Title = tw.h1`text-xl font-bold text-blue-600 mb-2`;
const FormContainer = tw.form`w-full max-w-2xl bg-white rounded-lg shadow-md p-4 mb-4 flex flex-wrap justify-between gap-4`; // Adjusted gap-4 for better spacing
const FormControl = tw.div`flex flex-col flex-1 mb-2`;
const Label = tw.label`text-base text-gray-800 mb-1`;
const Input = tw.input`p-1 border border-gray-300 rounded-lg w-full text-sm`;
const Select = tw.select`p-1 border border-gray-300 rounded-lg w-full text-sm`;
const Option = tw.option``;
const Button = tw.button`bg-blue-600 text-white px-3 py-1 rounded-lg font-semibold uppercase tracking-wide transition duration-300 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100 text-sm`;
const ErrorMessage = styled.p`
  ${tw`text-red-600 font-semibold mt-1 mb-3`}
`;

const PortfolioHoldings = () => {
  const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [exchange, setExchange] = useState("NFO")
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleShow = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      

      const getToken = () => localStorage.getItem('token');
      

      const response = await axios.get('https://falcon-algo.onrender.com/api/portfolio-holdings', {
        params: {
          exchange,
          startDate,
          endDate,
        },
        headers: {
            'Authorization': `Bearer ${getToken()}`
                  },
                  
      });

      console.log('Response data:', response.data);

      if (response.data.Status === 200 && Array.isArray(response.data.Success)) {
        setOrders(response.data.Success);
      }else if (response.data.Status === 500) {
        setError(response.data.Error || 'An error occurred');
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Error fetching data. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Title>Portfolio Holdings</Title>
      <FormContainer onSubmit={handleShow}>
        <FormControl>
          <Label>Exchange:</Label>
          <Select
            value={exchange}
            onChange={(e) => setExchange(e.target.value)}
            placeholder="Select Exchange"
          >
            <Option value="">Select Exchange</Option>
            <Option value="NFO">NFO</Option>
            <Option value="BFO">BFO</Option>
          </Select>
        </FormControl>
        <FormControl>
          <Label>Start Date:</Label>
          <Input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            placeholder="Select Start Date"
          />
        </FormControl>
        <FormControl>
          <Label>End Date:</Label>
          <Input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            placeholder="Select End Date"
          />
        </FormControl>
        <Button type="submit">Show</Button>
      </FormContainer>

      {loading && <p>Loading...</p>}
      {error && <ErrorMessage> {error}</ErrorMessage>}
      <PortfolioHolTable orders={orders} />
    </Container>
  );
};

export default PortfolioHoldings;
